import React from 'react';

const FinalizeStep = ({ formData, gasInfo, isEstimatingGas, isCreatingPool, onFinalize, onBack }) => {
  return (
    <>
      <div className="wrappermain">
        <div className="textformobile">
          <div className="parentmbl d-none">
            <div className="parent">
              <h6>Finalize</h6>
              <button>4/4</button>
            </div>
          </div>
        </div>
        <div className="mainboxmain">
          <img
            src={formData.selectedToken?.projectLogo || "\\assets\\blurimage.png"}
            alt={formData.selectedToken?.projectName || "img"}
            className="img-fluid blurimg"
          />
          <div className="midcontant">
            <img
              src={formData.selectedToken?.projectLogo || "\\assets\\img.png"}
              alt={formData.selectedToken?.projectName || "img"}
              className="img-fluid imgsett"

            />
            <h4>{formData.selectedToken?.projectName || "—"}</h4>
          </div>
        </div>
        <div className="communitybox lattttest">
          <h2>{formData.tagline || "—"}</h2>
          <p>{formData.poolDescription || "No description provided."}</p>
        </div>
        <div className="tokenbox lattttest">
          <div className="parenttoken">
            <div className="left">
              <h2>Creator Fee %</h2>
            </div>
            <div className="right">
              <p>{formData.creatorFee}%</p>
            </div>
          </div>
          <div className="parenttoken">
            <div className="left">
              <h2>Token Staking</h2>
            </div>
            <div className="right">
              <p>{formData.stakingAmount || "—"}</p>
              <img
                src={formData.selectedToken?.projectLogo || "\\assets\\img.png"}
                alt={formData.selectedToken?.projectName || "img"}
                className="img-fluid lastchange"
              />
            </div>
          </div>
        </div>
        <div className="feebox lattttest">
          <p className="gaspara">Gas Fees</p>
          <h2>
            {isEstimatingGas ? 'Estimating…' : gasInfo?.totalGasCostETHFormatted ? `${gasInfo.totalGasCostETHFormatted} ETH` : '—'}
          </h2>
        </div>
      </div>
      <div className="bottom-btns">
        <button className="backbtnbtn" onClick={onBack}>Back</button>
        <button
          className="continuebtn"
          onClick={onFinalize}
          disabled={isCreatingPool}
        >
          {isCreatingPool ? 'Processing…' : 'Stake & Finalize'}
        </button>
      </div>
    </>
  );
};

export default FinalizeStep;